import React from "react";
import { Popover } from "antd";

import { IPopoverProps } from "./interface";
import "./index.less";
import ZTypography from "../ZTypography";

const ZPopover: React.FC<IPopoverProps> = ({
	hideArrow = true,
	children,
	size = "md",
	overlayClassName,
	removeDefaultPadding = false,
	title = null,
	...rest
}) => {
	return (
		<Popover
			{...rest}
			overlayClassName={`size-${size} z-popover ${
				hideArrow ? "hide-arrow" : ""
			} ${
				removeDefaultPadding ? "z-popover-no-padding" : ""
			} ${overlayClassName}`}
			title={
				title && (
					<ZTypography.ZSectionHeading className="block my-2">
						{title}
					</ZTypography.ZSectionHeading>
				)
			}
		>
			{children}
		</Popover>
	);
};

export default ZPopover;
